export default "__VITE_ASSET__pb_pYE25__"